import gql from 'graphql-tag'

const mutation = gql`
mutation createRegion($fields: RegionInputReq!) {
	cashAssist {
	  createRegion(fields: $fields) {
	    id
	    mod_ver
	    name
	    departmentId
	  }
	}
}
`

export default mutation
